import { Service } from '@angular/core';
import { ReviewFile } from '@common/reviews/models/review-file.model';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';

@CollectionStateSelectors({
  stateType: ReviewFilesState
})
@State<ReviewFilesState>({
  name: ReviewFilesState.source
})
@Service({ autoProvided: false })
export class ReviewFilesState extends CollectionStateBase {
  static override source = 'ReviewFiles';
  getSource(): string {
    return ReviewFilesState.source;
  }
}

@Service()
export class ReviewFilesDataService extends CollectionDataServiceBase<ReviewFile> {
  protected readonly stateType = ReviewFilesState;
}
